<div class="container">
  <div class="heading_align">
    <div class="heading">Termini e condizioni d’uso<span class="font_14 font_normal"> - per Synappx™</span></div>
  </div>

  <div mat-dialog-content>
    @if (!showSCPToU) {
      <div mat-dialog-content>
        <div class="eula_points"><b>VALIDI DA: 25/04/2023</b></div>
        <div class="eula_points">
          I seguenti Termini d'uso di Synappx™, così come le <a tabindex="-1" class="text_underline" [href]="privacyUrl"
          target="_blank"><b>Norme sulla privacy di Synappx</b></a> incorporate qui per
          riferimento (collettivamente, il “Contratto”), sono tra Sharp Corporation (“Sharp”) e il Cliente. Questo
          Contratto regola l'accesso e l'uso di Synappx, così come di qualsiasi altro Servizio accessibile tramite
          Synappx. Ai fini di questo Contratto, con il termine “Synappx” si intende Synappx Go, il Portale Amministratore e relativa
          Documentazione; con il termine “Servizi” si intendono i Servizi Synappx, Servizi software specifici e tutta la relativa
          Documentazione che potrebbe essere proprietaria di Sharp e/o fornitori di servizi di terze parti ("Fornitori di servizi
          di terze parti") e che sono accessibili tramite il Servizio Synappx.
        </div>
      </div>
    }
    @if (showSCPToU) {
      <div mat-dialog-content>
        <div class="eula_points"><b>VALIDI DA: Luglio 11, 2023</b></div>
        <div class="eula_points">
          I seguenti Termini d'uso di Synappx™, così come le <a tabindex="-1" class="text_underline"
          [href]="privacyUrl" target="_blank"><b>Norme sulla privacy di Synappx</b></a> incorporate qui per
          riferimento (collettivamente, il “Contratto”), sono tra Sharp Corporation (“Sharp”) e il Cliente. Questo
          Contratto regola l'accesso e l'uso di Synappx, così come di qualsiasi altro Servizio accessibile tramite
          Synappx. Ai fini di questo Contratto, con il termine “Synappx” si intende Synappx Go, Synappx Cloud Print, il Portale Amministratore e relativa
          Documentazione; con il termine “Servizi” si intendono i Servizi Synappx, Servizi software specifici e tutta la relativa
          Documentazione che potrebbe essere proprietaria di Sharp e/o fornitori di servizi di terze parti ("Fornitori di servizi
          di terze parti") e che sono accessibili tramite il Servizio Synappx.
        </div>
      </div>
    }
    <div class="eula_points">
      L'uso dei Servizi è inteso per organizzazioni (Cliente") e i loro Utenti finali. Con il termine "Utenti
      finali" e le sue variazioni si intendono chiunque acceda ai servizi forniti dal Servizio Synappx e potrebbe
      includere, ma senza limitazione, dipendenti del Cliente, rappresentanti, collaboratori, agenti e altri
      individui che usano o accedono ai Servizi tramite un Account cliente e con l'autorizzazione da parte del
      Cliente di utilizzare i Servizi. Tutti i riferimenti al termine "Cliente" faranno anche riferimento agli
      Amministratori autorizzati del Cliente e a qualsiasi rispettivo Utente finale, sia individualmente e
      collettivamente.
    </div>
    <div class="eula_points">
      Prima di qualsiasi uso e accesso riconosciuto al Cliente, gli Amministratori autorizzati per il Cliente
      devono accettare questo Contratto per conto del Cliente. Facendo clic su "Accetto", tu, l'Amministratore,
      affermi e garantisci che: 1) sei stato/a designato/a dal Cliente come "Amministratore" e hai diritto a tutti
      i diritti e privilegi riconosciuti a coloro che hanno il ruolo di Amministratore (più nel dettaglio di
      seguito); 2) hai l'autorità di legare il Cliente a questo Contratto. Se non sei stato/a designato/a come
      Amministratore per il Cliente o non hai l'autorità riportata sopra, non puoi fare clic su "Accetto" e il
      Cliente non può usare i Servizi o accedere a essi. Facendo clic su "Accetto", il Cliente avrà il diritto di
      usare e accedere ai Servizi sotto i termini definiti qui.
    </div>
    <div class="eula_points">
      Potrebbero esserci altri servizi software specifici ("Servizi software specifici") accessibili all'interno o
      tramite i Servizi Amministrativi Synappx che permettono al Cliente di effettuare determinate funzioni o
      usare servizi e funzionalità ulteriori; questi Servizi software specifici sono proprietà di Sharp e/o di
      Fornitori di servizi di terze parti. Il Cliente comprende che l'uso e/l'accesso a questi Servizi software
      specifici può richiedere che il Cliente, gli Amministratori e/o gli Utenti finali accettino termini e
      condizioni aggiuntivi, applicabili all'uso e/o all'accesso dei Servizi software specifici ("Termini
      aggiuntivi"). Se il Cliente, gli Amministratori, e/o gli Utenti finali non accettano tali termini o non
      hanno l'autorità di accettare tali Termini aggiuntivi, il Cliente, gli Amministratori e/o gli Utenti finali
      non possono usare o accedere a quei Servizi software specifici, laddove applicabile. In caso di incongruenze
      tra questo Contratto e i Termini aggiuntivi, i Termini aggiuntivi controlleranno solo ciò che riguarda quel
      dato Servizio software specifico.
    </div>

    <div>
      <div class="eula_points">
        <b>A. Definizioni</b> <br />
        In aggiunta a tutti i termini definiti sopra, le seguenti definizioni si applicano a questo Contratto:
        <ol>
          <li> <b>Account cliente:</b> Si riferisce a tutti gli account al di sotto
          di o assegnati a un Cliente. Ciò include tutti gli Account amministratore applicabili così come
          tutti i Servizi concessi in licenza e informazioni e dati associati a Cliente, Amministratori e
        i rispettivi Utenti finali.</li>
        <li> <b>Amministratore:</b> Un dipendente designato dal Cliente per gestire
        le informazioni e i dati associati all'Account cliente, così come l'accesso e le licenze
      relativi ai Servizi per conto del Cliente.</li>
      <li> <b>Account amministratore:</b> Questo fa riferimento all’account
    dell’amministratore.:</li>
    <li> <b>Dati dei clienti:</b> Tutti i dati e le informazioni memorizzati,
    trasmessi, elaborati o ottenuti tramite i Servizi dal Cliente, dagli Amministratori e/o dai
  relativi Utenti finali o associati con un Account cliente.</li>
  <li> <b>Commerciante:</b> Il rivenditore autorizzato dei Servizi al
  Cliente; il Commerciante potrebbe essere Sharp, un'azienda consociata o succursali di vendita
  diretta dell'azienda consociata (in caso di vendite dirette a un Cliente) o un rivenditore di
  terze parti autorizzato di prodotti e servizi Sharp. Il Commerciante è anche il contatto
  principale per il Cliente in caso di necessità di assistenza in merito ai Servizi. Il rifornitore
  potrebbe fornire servizi per il Cliente in conformità a un accordo con il Cliente e/o
Amministratore.</li>
<li> <b>Documentazione:</b> Qualsiasi guida all'installazione o per
l'utente, file di aiuto, domande frequenti per accedere o utilizzare i Servizi.</li>
<li> <b>Diritti di proprietà intellettuale:</b> Tutti i diritti, attuali o
futuri, sotto brevetto, copyright, segreto commerciale, marchio registrato, diritti morali e
altri diritti di proprietà intellettuale.</li>
</ol>
</div>
<div class="eula_points">
  <b>B. Uso e responsabilità del cliente </b>
  <ol>
    <li> Il Cliente è responsabile della designazione di quali individui sono autorizzati e avranno il
      ruolo di Amministratore per conto del Cliente. Gli Account Amministratore possono essere
    assegnati e riassegnati dal Cliente.</li>
    <li> Il Cliente è responsabile di: gestire l'accesso agli Account Amministratore e assicurarsi che
      l'accesso ai e/o l'uso dei Servizi da parte del Cliente, degli Amministratori e degli Utenti
      finali siano conformi a questo Contratto, ai Termini aggiuntivi e a qualsiasi altra
      Documentazione applicabile. Sharp e il Commerciante non sono responsabili per la gestione
    interna, l'amministrazione o l'uso dei Servizi per conto del Cliente.</li>
    <li> Il Cliente comprende e accetta che i suoi Amministratori e Utenti finali sono governati da e
      rispetteranno questo Contratto, i Termini aggiuntivi, la Documentazione e qualsiasi legge,
      regolamento e regola applicabile in relazione all'uso dei Servizi. Il Cliente sarà l'unico
      responsabile di tutti gli atti o le omissioni di Cliente, i suoi Amministratori e Utenti finali
      o della loro incapacità di rispettare i termini di questo Contratto, Termini aggiuntivi,
      Documentazione o qualsiasi legge, regolamento o regola applicabile in relazione all'uso dei
      Servizi. Questa responsabilità si estende a tutte le attività sotto un Account cliente, a
      prescindere se le attività siano o meno effettuate dal Cliente, dai suoi dipendenti o da una
      terza parte (inclusi, ma senza limitazione, collaboratori, rappresentati o agenti del Cliente).
    </li>
    <li> Il Cliente è responsabile di assicurarsi che gli Amministratori e gli Utenti finali rispettino
      qualsiasi obbligazione, termine e norma applicabile del Cliente pertinente all'accesso e all'uso
    dei Servizi.</li>
    <li> Il Cliente accetta di proteggere e conservare tutti i consensi applicabili dagli Utenti finali
      per permettere agli Amministratori di intraprendere tutte le attività descritte in questo
      Contratto e per permettere a Sharp e/o Fornitori di servizi di terze parti di fornire i Servizi.
    </li>
    <li> Il Cliente è responsabile di e deve prevenire l'accesso non autorizzato a e/o l'uso dei Servizi
      da parte del Cliente, degli Amministratori e Utenti finali e di qualsiasi terza parte. Il
      Cliente avvertirà immediatamente Sharp e il Commerciante su qualsiasi accesso e/o uso non
      autorizzato dei Servizi. Sharp e il Commerciante non saranno responsabili dell'uso e
    dell'accesso non autorizzato agli Account cliente.</li>
    <li> Il Cliente userà solo i Servizi per le proprie operazioni aziendali interne, e non per
      un'agenzia di servizi o un servizio di time-sharing. Il Cliente non userà o permetterà
      l'utilizzo, coscientemente o volontariamente, dei Servizi in una maniera che possa danneggiare,
      disattivare, sovraccaricare, compromettere o altrimenti interferire con la fornitura dei
      Servizi; ciò include, ma senza limitazione, l'uso dei Servizi per trasmettere virus o file
    corrotti che potrebbero compromettere l'integrità e la sicurezza dei servizi in alcun modo.</li>
    <li> Il Cliente non farà quanto segue e si assicurerà che i suoi Amministratori o Utenti finali non
      facciano quanto segue, direttamente o indirettamente: (a) effettuare operazioni di ingegneria
      inversa, decompilare, disassemblare o tentare altrimenti di scoprire codici di sorgente, codici
      oggetto o strutture sottostanti, idee o algoritmi dei Servizi o di qualsiasi software,
      Documentazione o dai relativi a o forniti con o tramite i Servizi; (b) modificare, tradurre o
      creare opere derivative in base ai Servizi; oppure copiare (eccetto per scopi di archiviazione),
      affittare, allocare, distribuire, vendere, rivendere, impegnare, assegnare o altrimenti
      trasferire o gravare i diritti nei o ai Servizi; (c) usare o accedere ai Servizi per costruire o
      supportare, e/o assistere una terza parte nella costruzione o il supporto, di prodotti o servizi
      concorrenti ai Servizi; oppure (d) rimuovere o cambiare avvisi o etichette proprietari dai
    Servizi.</li>
    <li> Inoltre, il Cliente non farà quanto segue e si assicurerà che i suoi Amministratori o Utenti
      finali non facciano quanto segue: (a) usare i Servizi per attività dove l'uso o eventuali
      problemi dei Servizi possano provocare danni fisici, lesioni personali o morte; (b) usare i
      Servizi o permettere l'utilizzo dei Servizi per attività illegali, fraudolente, offensive o
      dannose; (c) usare i Servizi in un modo che possa danneggiare, disattivare, sovraccaricare,
      compromettere o altrimenti interferire con la fornitura dei Servizi, incluso per mezzo di invio
      di virus o file corrotti; oppure (d) usare i Servizi per infrangere o appropriarsi senza diritti
    dei Diritti di proprietà intellettuale o diritti proprietari di altri.</li>
    <li> Il Cliente comprende che il Cliente è responsabile del rispetto di qualsiasi conformità
      regolatoria applicabile e specifica per il verticale o il settore industriale, e che Sharp, il
      Commerciante e/o i Fornitori di servizi di terze parti non si assumeranno alcuna responsabilità
    per l'incapacità del Cliente di fare ciò.</li>
    <li> Il Cliente sarà l'unico responsabile dell'ottenimento e della manutenzione di attrezzatura e
      servizi accessori appropriati necessari a connettersi a, accedere a, fornire o altrimenti usare
      i Servizi, inclusi, ma senza limitazione, computer, sistemi operativi e browser web per
      computer, accesso a Internet, dispositivi mobili, dispositivi periferici multifunzione ("MFP"),
      sistemi di display, altri dispositivi elettronici e accessori (collettivamente, "Attrezzatura").
      Il Cliente si assicurerà che l'Attrezzatura sia conforme a tutte le configurazioni e le
      specifiche stabilite nella Documentazione, laddove presente, per i Servizi. La documentazione
      relativa a Servizi software specifici può essere accessibile tramite i Servizi software
    specifici.</li>
    <li> Nell'eventualità in cui il Cliente abbia un contratto di iscrizione in corso con il
      Commerciante o un Fornitore di servizi di terze parti riguardo ai Servizi, o a una porzione
      degli stessi, il Cliente si assicurerà che sia conforme a tale contratto, incluso il pagamento
      di tutte le tariffe applicabili, e un'eventuale inadempienza potrebbe risultare nella
      sospensione o terminazione dell'Account cliente o dell'accesso ai e dell'utilizzo dei Servizi, o
    di una porzione degli stessi.</li>
    <li> Nell'eventualità in cui ci sia una citazione a giudizio, un ordine giudiziario o un'altra
      richiesta valida ricevuta dal Cliente relativamente ai Servizi, a un Account cliente o ai Dati
      dei clienti, il Cliente sarà responsabile della risposta a tali richieste tramite accesso ai
      propri Dati di cliente. Se il Cliente non dovesse essere in grado di accedere ai Dati dei
      clienti richiesti o ad altre informazioni richieste, il Cliente contatterà Sharp per ricevere
      assistenza e Sharp compirà sforzi commercialmente ragionevoli per assistere il Cliente a tale
      riguardo. Se il Cliente non risponde in maniera tempestiva, Sharp potrebbe rispondere a tale
      richiesta di terze parti, ma non si riterrà obbligata a rispondere. Nell'eventualità in cui ci
      sia una citazione a giudizio, un ordine giudiziario o un'altra richiesta valida ricevuta da
      Sharp, il Commerciante e/o un Fornitore di servizi di terze parti relativamente ai Servizi, a un
      Account cliente o a Dati dei clienti, inclusi, ma senza limitazione, Account Amministratore o
      qualsiasi dato all'interno di Account cliente, Sharp, il Commerciante e/o un Fornitore di
      servizi di terze parti ottempererà a tale citazione a giudizio, ordine giudiziario o altra
      richiesta in quanto potrebbe essere richiesto dalle leggi applicabili. Ulteriori informazioni
      relative all'utilizzo degli o all'accesso potenzialmente necessario da parte di Sharp agli
      Account Clienti sono descritte nelle <a tabindex="-1" class="text_underline" [href]="privacyUrl"
      target="_blank"><b>Norme sulla privacy di Synappx</b></a>.</li>
      <li> Il Cliente sarà responsabile di qualsiasi infrazione di questa sezione da parte del Cliente,
        incluso qualsiasi Amministratore o Utente finale. Il Cliente riconosce e comprende che Sharp, il
        Commerciante e i Fornitori di servizi di terze parti non saranno ritenuti responsabili verso il
      Cliente o altrimenti per alcuna azione intrapresa da un Utente finale.</li>
    </ol>
  </div>
  <div class="eula_points">
    <b>C. Ruolo dell'Amministratore</b>
    <ol>
      <li> Tutti gli Amministratori devono utilizzare i Servizi in ottemperanza con questo Contratto, i
        Termini aggiuntivi, la Documentazione, se applicabile, e qualsiasi e ogni obbligazione
        sull'occupazione e termini e norme del Cliente, così come qualsiasi legge, regole o regolamento
      applicabile per accedere a e/o utilizzare i Servizi.</li>
      <li> L'Amministratore comprende che gli Account Amministratore aggiuntivi possono essere assegnati e
      riassegnati dal Cliente.</li>
      <li> Usando l'Account Amministratore Synappx, un Amministratore mantiene il controllo sull'Account
        Cliente gestendo tale Account, incluse tutte le licenze (individuali o collettive) associate con
      l'Account Cliente.</li>
      <li> L'Amministratore può configurare, concedere l'accesso, monitorare, restringere, sospendere o
        terminare l'accesso a tutti gli Account cliente, inclusi Account Amministratore aggiuntivi,
      licenze di Spazi di lavoro o Licenze per Utenti finali.</li>
      <li> L'Amministratore può anche essere un Utente finale: in tal caso tutti i termini in questo
        Contratto o Termini aggiuntivi relativi a un Utente finale si applicheranno all'Amministratore
      nella usa capacità in quanto Utente finale.</li>
    </ol>
  </div>
  <div class="eula_points">
    <b>D. Utilizzo da parte dell'Utente finale</b>
    <ol>
      <li> Il Cliente si assicurerà che l'Utente finale utilizzi i Servizi in ottemperanza con questo
        Contratto, i Termini aggiuntivi, la Documentazione, se applicabile, e qualsiasi e ogni
        obbligazione sull'occupazione e termini e norme del Cliente, così come qualsiasi legge, regole o
      regolamento applicabile per accedere a e/o utilizzare i Servizi.</li>
      <li> Il Cliente è responsabile dell'accesso e dell'uso dei Servizi da parte degli Utenti finali.
      </li>
      <li> Un Utente finale non può dissociare la propria attività nei Servizi dal Cliente.</li>
      <li> Il Cliente dichiara e garantisce che: (a) l'Utente finale ha tutti i diritti e le licenze per
        accedere e usare i Servizi; e (b) che la memorizzazione, la trasmissione, l'elaborazione di
        qualsiasi informazione relativa a e l'accesso dell'Utente finale ai Servizi non viola i termini
        di questo Contratto, i Termini aggiuntivi, la Documentazione rilevante, i Diritti di proprietà
        intellettuale o diritti proprietari di altri, o qualsiasi legge, regola o regolamento
      applicabile.</li>
      <li> Il Cliente riconosce di essere il solo responsabile per la natura, la qualità e l'accuratezza
      di qualsiasi attività dell'Utente finale in connessione dei Servizi.</li>
    </ol>
  </div>
  <div class="eula_points">
    <b>E. Ruolo del Commerciante</b>
    <ol>
      <li> Il Commerciante è responsabile della configurazione di un Account cliente e di fornire le
        licenze per i Servizi agli Amministratori. Una volta che un Amministratore per il Cliente viene
      creato, il Commerciante non avrà alcuna abilità di creare Account Amministratore.</li>
      <li> I Fornitori possono gestire le licenze per gli Account cliente, incluso l'acquisto o la
        terminazione di una licenza. Un Commerciante non sarà in grado di terminare qualsiasi licenza
        che sia stata già fornita all'Amministratore a meno che non sia altrimenti espressamente
      stabilito in questo Contratto.</li>
      <li> I Commercianti avranno accesso a informazioni di base riguardo agli Account cliente, così come
        al nome del Cliente, i relativi numeri di telefono e indirizzo, e i nomi e gli indirizzi email
        di tutti gli Amministratori. I Commercianti avranno anche accesso e avranno facoltà di
      visualizzare tutte le licenze Account cliente ai Servizi.</li>
      <li> I Commercianti possono sospendere e/o cancellare un accesso di un Cliente all'Account cliente.
      </li>
      <li>Nell'eventualità in cui il Rifornitore non sia in grado o non sia più autorizzato a prestare
        supporto a un Account
        cliente, Sharp o una sussidiaria potranno trasferire l'Account cliente a un altro Rifornitore a
        propria sola
        discrezione. Un Commerciante non è in grado di trasferire un Account cliente a un altro
      Commerciante per conto proprio.</li>
      <li>Il rifornitore può usare i servizi come utente finale a richiesta del cliente.</li>
    </ol>
  </div>
  <div class="eula_points"><b>F. Servizi</b>
  <ol>
    <li> I Clienti possono soltanto accedere e utilizzare i Servizi in accordo con i termini di questo
      Contratto, Termini aggiuntivi, Documentazione e qualsiasi termine d'uso o norme sulla privacy
      aggiuntivi applicabili all'accesso e/o all'uso dei Servizi. L'incapacità del Cliente di
      rispettare questo Contratto, i Termini aggiuntivi, la Documentazione e qualsiasi legge, regole o
      regolamento applicabile può portare tale Account cliente o Account Amministratore a essere
    sospeso o terminato a sola discrezione di Sharp.</li>
    <li> I Servizi o una loro porzione possono essere soggetti a contratti di iscrizione con il
      Commerciante e/o Fornitori di servizi di terze parti; l'incapacità del Cliente di rispettare
      tali contratti, inclusi, ma senza limitazione, i pagamenti di tutte le tariffe applicabili, può
      risultare nella sospensione o terminazione dell'Account cliente o dell'accesso e dell'uso dei
    Servizi, o di una porzione degli stessi, come risultato di tale incapacità.</li>
    <li> L'accesso ai e l'uso dei Servizi è anche soggetto alla ricezione di Sharp di tutte le tariffe
      dal Commerciante per l'accesso del Cliente ai e dell'uso dei Servizi; nell'eventualità in cui
      Sharp, o una sua società consociata, non abbia ricevuto qualsiasi tariffa applicabile al tuo
      Account cliente dal tuo Commerciante, e tale mancanza non sia rimediata entro trenta (30) giorni
      dal relativo avviso, Sharp, o la sua società consociata, può, a sua sola discrezione, sospendere
      o terminare il tuo Account cliente finché Sharp, o la sua società consociata, non riceve tale
    pagamento dovuto.</li>
    <li> Sharp impiegherà sforzi commercialmente ragionevoli per assicurare che tutte le strutture usate
      per conservare ed elaborare i Dati dei clienti rispettino standard di sicurezza commercialmente
      ragionevoli. Utilizzando i Servizi, il Cliente consente al trasferimento, all'elaborazione e
    alla conservazione dei Dati dei clienti da parte di Sharp.</li>
    <li> Il Cliente comprende che Sharp e/o i Fornitori di servizi di terze parti possono aggiornare i
    Servizi occasionalmente con o senza avviso al Cliente.</li>
    <li> In deroga a qualsivoglia disposizione contraria, nell'eventualità che sia determinato che i
      Dati dei clienti violino o possano violare questo Contratto o compromettere, sovraccaricare
      oppure minacciare o provocare danni ai Servizi in qualsiasi modo, tali Dati dei clienti possono
      essere eliminati, per intero o in parte, a sola discrezione di Sharp, con o senza avviso al
      Cliente e senza alcuna responsabilità da parte di Sharp. Il Cliente sarà responsabile di
    assicurare il backup dei Dati dei clienti nell'eventualità di tale eliminazione.</li>
    <li> Ulteriori termini relativi alla privacy, all'elaborazione e alla conservazione dei Dati dei
      clienti, così come all'accesso agli Account cliente, sono definiti nelle <a tabindex="-1"
      class="text_underline" [href]="privacyUrl" target="_blank"><b>Norme sulla privacy di
    Synappx</b></a> e dalla Documentazione applicabile ai Servizi.</li>
  </ol>
</div>
<div class="eula_points"><b>G. Assistenza</b>
<ol>
  <li> Il Cliente è responsabile di contattare il Commerciante per qualsiasi questione inerente
    all'assistenza ai Servizi che non possa essere risolta tramite la Documentazione per Servizi
  software specifici.</li>
  <li> A meno che Sharp o una succursale commerciale di Sharp sia il Commerciante per il tuo Account
    cliente, Sharp non è responsabile per il Cliente per qualsiasi domanda relativa all'assistenza
    dei Servizi di cui sopra e al di là di quanto è fornito tramite la Documentazione per Servizi
  software specifici.</li>
</ol>
</div>
<div class="eula_points"><b>H. Proprietà intellettuale</b>
<ol>
  <li> Questo Contratto non riconosce a Sharp, al Commerciante o a qualsiasi Fornitore di servizi di
    terze parti alcun diritto verso i Dati dei clienti o i diritti di proprietà intellettuale
    incorporati in qualsiasi Account cliente, Account Amministratore, fatta eccezione per diritti
    limitati espressamente delineati in questo Contratto o Termini aggiuntivi o che sono altrimenti
  necessari a fornire i Servizi e permettere al Cliente di usare i Servizi.</li>
  <li> A meno che non sia specificamente espresso in questo Contratto o in Termini aggiuntivi, al
    Cliente, agli Amministratori o agli Utenti finali non sono riconosciuti: (a) Diritti di
    proprietà intellettuale nei o verso i Servizi o qualsiasi porzione degli stessi; (b) Diritti di
    proprietà intellettuale negli o verso gli Account cliente; oppure (c) nessun diritto di usare i
    logo, i marchi registrati, i marchi di servizio, i nomi di dominio o funzionalità di brand di
    Sharp, del Commerciante, di Fornitori di servizi di terze parti, dei Servizi o di qualsiasi
  componente dei Servizi.</li>
  <li> Nella misura in cui viene richiesto a Sharp da un Cliente, dagli Amministratori o da un Utente
    finale per certe azioni, inclusi, ma senza limitazione, trasmissione, memorizzazione o
    condivisione di file, utilizzo di o concessione dell'accesso a funzionalità e impostazioni dei
    prodotti, allora il Cliente concede a Sharp il permesso di effettuare tutte le azioni necessarie
    per Sharp o il Commerciante al fine di fornire i Servizi e le funzionalità disponibili tramite i
    Servizi e come potrebbe essere delineato nella Documentazione. Questo permesso si estende a
  qualsiasi servizio di Fornitori di terze parti che Sharp utilizza per fornire i Servizi.</li>
</ol>
</div>

<div class="eula_point">
  <div><b>I. Disclaimer</b></div>
  <div class="eula_point_left">SHARP IMPIEGERÀ OGNI SFORZO COMMERCIALMENTE RAGIONEVOLE PER RENDERE
    DISPONIBILI I SERVIZI PER L'USO E L'ACCESSO DEL CLIENTE IN ACCORDO CON QUESTO CONTRATTO, TERMINI
    AGGIUNTIVI E LA DOCUMENTAZIONE APPLICABILE. IN DEROGA A QUALSIVOGLIA DISPOSIZIONE CONTRARIA, I
    SERVIZI SONO FORNITI "COSÌ COME SONO". NELLA MISURA MAGGIORE PERMESSA DALLA LEGGE, ECCETTO LADDOVE
    ESPRESSAMENTE DEFINITO IN QUESTO CONTRATTO, SHARP NON DÀ ALCUNA GARANZIA PER CONTO PROPRIO, DEL
    COMMERCIANTE O DI QUALSIASI FORNITORE DI TERZE PARTI, CHE SIA ESPRESSA, IMPLICITA O ALTRIMENTI,
    INCLUSE GARANZIE CHE IL SERVIZIO RESTERÀ SENZA INTERRUZIONI, SENZA ERRORI, CHE I CONTENUTI SARANNO
    PROTETTO O NON ALTRIMENTI PERDUTI O DANNEGGIATI, CHE I DIFETTI SARANNO CORRETTI, OPPURE DI
    COMMERCIABILITÀ, ADEGUATEZZA PER UN PARTICOLARE USO O NON INFRAZIONE. SHARP NON FA ALCUNA
    DICHIARAZIONE SUI CONTENUTI, INCLUSI I DATI DEI CLIENTI ALL'INTERNO DI O DA ACCOUNT CLIENTE E IL
    CLIENTE SARÀ L'UNICO RESPONSABILE PER TUTTI I DATI CLIENTE, COSÌ COME PER L'ACCESSO AI E L'USO DEI
  SERVIZI.</div>
</div>

<div class="eula_points"><b>J. Durata e termine</b>
<ol>
  <li> Questo Contratto resterà in effetto fino al momento in cui il Cliente non avrà più
    un'iscrizione valida o un accesso valido ai Servizi o al momento in cui questo Contratto sarà
    terminato in accordo con i termini definiti in questo Contratto. Il Cliente comprende che certi
    Servizi software specifici possono terminare in maniera anticipata in accordo con eventuali
  disposizioni di Termini aggiuntivi applicabili.</li>
  <li> Il Commerciante può terminare un Account cliente nell'eventualità in cui il Cliente non paghi
    eventuali tariffe di iscrizione dovute al Commerciante per l'utilizzo o l'accesso da parte del
  Cliente ai Servizi.</li>
  <li> Sharp può terminare questo Contratto e il tuo accesso e utilizzo dei Servizi nell'eventualità
    in cui Sharp non riceva pagamenti di tariffe dal Commerciante per l'uso e l'accesso del Cliente
    ai Servizi e tale mancanza non venga rimediata entro trenta (30) giorni dal relativo avviso
    scritto; tale sospensione o terminazione può continuare a essere in effetto finché Sharp non
  riceve il pagamento dovuto.</li>
  <li> Questo Contratto e l'accesso e l'uso dei Servizi si rinnoverà automaticamente a meno che il
  Cliente non avvisi il Commerciante della propria intenzione di terminare i Servizi.</li>
  <li> In aggiunta, Sharp, o la sua società consociata, può terminare questo Contratto se il Cliente
    infrange qualsiasi termine materiale di questo Contratto e non rimedia l'infrazione entro trenta
    (30) giorni dopo la ricezione dell'avviso scritto dell'infrazione; tale avviso scritto può
  assumere la forma di un'email o di un'altra notifica elettronica.</li>
  <li> Nell'eventualità di una terminazione di questo Contratto, i diritti riconosciuti al Cliente,
    agli Amministratori e agli Utenti finali cesseranno immediatamente, fatta eccezione per il fatto
    che l'Account cliente e i Dati dei clienti all'interno di un Account cliente saranno accessibili
    per quindici (15) giorni a seguito della data effettiva di termine dell'iscrizione. Al momento
    della scadenza o della terminazione di questo Contratto per qualsivoglia motivazione, ad
    eccezione del caso in cui sia esplicitamente autorizzato in questa Sezione, il Cliente accetta
    di interrompere immediatamente ogni accesso e utilizzo dei Servizi. Il Cliente riconosce e
    accetta che Sharp e/o i Fornitori di servizi di terze parti non avranno alcun obbligo di
    conservare i Dati dei clienti a seguito del periodi di trenta (30) giorni a cui si è fatto
    riferimento e che a seguito di questo periodo di trenta (30) giorni tutti i Dati dei clienti
  saranno irrimediabilmente eliminati.</li>
  <li> In deroga a qualsiasi terminazione o scadenza di questo Contratto, il Cliente resterà
    responsabile di qualsiasi pagamento di tariffe che sia dovuta al Commerciante ai sensi del
    Contratto con il tuo Commerciante o che possa essere altrimenti dovuto al Commerciante per
    eventuale uso o accesso ai Servizi precedentemente alla data effettiva di terminazione o
  scadenza di questo Contratto.</li>
  <li> Gli avvisi al Cliente trattati in questa sezione possono assumere la forma di un'email o di
  altre notifiche elettroniche e possono essere diretti agli Amministratori.</li>
  <li> Le seguenti sezioni di questo Contratto continueranno a essere in vigore a seguito della
    scadenza o della terminazione di questo Contratto per qualsivoglia motivazione: Sezioni F(6), H,
  I, da J(6) a J(9), K, L, M, Q e S.</li>
  <li>I punti da 1 a 9 di questo articolo J (Termine e terminazione) non sono applicati per Synappx
    Manage. Synappx Manage
    potrebbe terminare l’uso gratuito in qualsiasi istante e per qualunque ragione a sola
    discrezione di Sharp, senza alcuna
  responsabilità per te.</li>
</ol>
</div>
<div class="eula_point">
  <div><b>K. Indennizzo</b></div>
  <div class="eula_point_left">Il Cliente indennizzerà, difenderà e terrà indenne Sharp, i suoi
    Commercianti, i Fornitori di servizi di terze parti e ciascuno dei suoi affiliati, inclusi ma senza
    limitazione società principali o consociate, direttori, ufficiali, dipendenti, agenti e
    collaboratori (collettivamente, "Parti Sharp") da e contro ogni responsabilità, danno e costo
    (inclusi costi di compensazione e tariffe ragionevoli di avvocati) derivanti dalle rivendicazioni di
    terze parti riguardo a: (a) uso dei Servizi da parte del Cliente; (b) tutti i Dati dei clienti; (c)
    qualsiasi infrazione o violazione di questo Contratto da parte del Cliente, degli Amministratori e/o
    un Utente finale; e (d) qualsiasi violazione o presunta violazione di qualsiasi legge, regola o
    regolamento applicabile al Cliente, all'Amministratore e/o all'Utente finale riguardo ai Servizi.
    Sharp intraprenderà azioni commercialmente ragionevoli per avvisare il Cliente in caso di tali
  rivendicazioni o richieste soggette a questa sezione.</div>
</div>

<div class="eula_point">
  <div><b>L. Limitazione di responsabilità</b></div>
  <div class="eula_point_left">NELLA MAGGIORE MISURA PERMESSA DALLA LEGGE, IN NESSUNA EVENTUALITÀ LE PARTI
    SHARP SARANNO RESPONSABILI NEI CONFRONTI DEL CLIENTE, DI AMMINISTRATORI E UTENTI FINALI OPPURE DI
    EVENTUALI TERZE PARTI PER DANNI DIRETTI, SPECIALI, ACCIDENTALI, INDIRETTI, PUNITIVI O
    CONSEGUENZIALI, INCLUSI, MA SENZA LIMITAZIONE, PERDITA DI PROFITTI, DATI UTILIZZO O CONTENUTI O
    ALTRE PERDITE DERIVANTI DA O RELATIVI A QUESTO CONTRATTO, TERMINI AGGIUNTIVI, I SERVIZI, L'ACCOUNT
    CLIENTE O DATI CLIENTI. QUESTO PARAGRAFO SARÀ APPLICATO A PRESCINDERE CHE LA TEORIA DI
    RESPONSABILITÀ SIA BASATA SU CONTRATTO, TORTO, NEGLIGENZA, INFRAZIONE DELLA GARANZIA, RESPONSABILITÀ
    STRETTA O ALTRIMENTI E A PRESCINDERE CHE LE PARTI SHARP ABBIANO ESPRESSO UN AVVISO O MENO RIGUARDO
    ALLA POSSIBILITÀ DI TALI DANNI. IN NESSUNA EVENTUALITÀ LA RESPONSABILITÀ CUMULATIVA DELLE PARTI
    SHARP VERSO IL CLIENTE O EVENTUALI TERZE PARTI SARÀ MAGGIORE DI UNA SOMMA EQUIVALENTE A TRE MESI
    DELLE TARIFFE DEL TUOI SERVIZI. CON QUESTO CONTRATTO TU SOLLEVI LE PARTI SHARP DA QUALSIASI
    OBBLIGAZIONE, RESPONSABILITÀ E RIVENDICAZIONE CHE ECCEDA QUESTA LIMITAZIONE. QUESTA LIMITAZIONE DI
    RESPONSABILITÀ SOPRAVVIVERÀ ALLA SCADENZA O ALLA TERMINAZIONE DI QUESTO CONTRATTO PER QUALSIVOGLIA
    MOTIVAZIONE E SI APPLICHERÀ SE QUALSIASI RIMEDIO LIMITATO SPECIFICATO IN QUESTA SEZIONE VIENE
  CONSIDERATO COME INADATTO A SERVIRE AL PROPRIO SCOPO.</div>
</div>

<div class="eula_point list_custom">
  <div><b>M. Legge applicabile / Rinuncia a processo con giuria</b></div>
  <div class="eula_point_left">Se il Cliente usa i Servizi solo per scopi personali e non di business,
    questo accordo sarà regolato dalle leggi della
  giurisdizione in cui il Cliente ha acquistato o ottenuto la licenza per usare i servizi.</div>
  <div class="eula_point_left">Se il Cliente non è un consumatore, questo Accordo sarà regolato da e
  interpretato in accordo con le leggi in vigore in:</div>
  <ol>
    <li>
      Stato di New York, se una licenza per l’uso dei Servizi è acquistata o ottenuta quando il
      Cliente è negli Stati Uniti,
      Canada, o Messico;
    </li>
    <li>
      Inghilterra e Galles, se la licenza d'uso dei Servizi viene acquistata quando il Cliente si trova nel Regno Unito o
      in un qualsiasi paese del SEE;
    </li>
    <li>Il Paese dell’Unione Europea in cui si trova il Cliente, se una licenza per l’uso di questi
      Servizi è acquistata o
    ottenuta dal Cliente in quel paese dell’Unione Europea;</li>
    <li>
      Giappone, se una licenza per l’uso dei Servizi è acquistata o ottenuta quando il Cliente è in
      una giurisdizione non fra
      quelle descritte;
    </li>
  </ol>
  <div class="eula_point_left">I tribunali competenti rispettivamente di :</div>
  <ol>
    <li>
      Contea di New York, New York quando si applica la legge di New York;
    </li>
    <li>
      Inghilterra e Galles, quando si applica la legge dell’Inghilterra e del Galles;
    </li>
    <li>
      Il paese dell’Unione Europea del Cliente quando si applica la legge di quel paese dell’Unione
      Europea;
    </li>
    <li>
      Il tribunale del distretto di Osaka in Giappone, quando si applica la legge giapponese

    </li>
    Ciascuno avrà giurisdizione non esclusiva su tutte le dispute relative al presente Accordo.
  </ol>
  <div class="eula_point_left">Qualsiasi rivendicazione sotto questo Contratto contro le Parti Sharp deve essere presentata entro un (1) anno
    dall'insorgere della causa dell'azione, altrimenti la rivendicazione o la causa dell'azione viene esclusa. Con il
    presente, il Cliente e Sharp rinunciano al processo con giuria per qualsiasi disputa relativa a questo Contratto o ai
  Servizi.</div>
</div>

<div class="eula_point">
  <div><b>N. Marchi</b></div>
  <div class="eula_point_left">I marchi o marchi di servizi “SHARP”, “Synappx”, ”Synappx Meeting”,
    ”Synappx Go” e qualsiasi altro nome di prodotto, nome di servizio o logo pertinente utilizzato,
    citato e/o a cui viene fatto riferimento su o tramite i Servizi sono marchi, marchi registrati o
    marchi di servizi di Sharp e/o le sue entità affiliate. Tutti gli altri prodotti, nomi di servizi,
    loghi e/o nomi di aziende che appaiono su o tramite i Servizi sono proprietà dei loro rispettivi
    proprietari e possono essere protetti come loro marchi, marchi registrati, marchi di servizi e/o
  nomi commerciali.</div>
</div>

<div class="eula_point">
  <div><b>O. Forza maggiore</b></div>
  <div class="eula_point_left">Le Parti Sharp, i Fornitori di servizi di terze parti e il Cliente non
    saranno ritenuti responsabili per prestazioni inadeguate nella misura in cui queste sono causate da
    condizioni che vanno oltre ciò che è il controllo ragionevole delle parti, inclusi, ma senza
    limitazione, disastri naturali, atti di guerra, terrorismo o ostilità, rivolte, azione governativa,
    condizioni lavorative oppure disturbi o guasti elettrici, delle telecomunicazione o di Internet.
    Sharp e il Cliente accettano di impiegare sforzi ragionevoli per mitigare gli effetti di qualsiasi
  evento di forza maggiore.</div>
</div>

<div class="eula_point">
  <div><b>P. Esportazione</b></div>
  <div class="eula_point_left">Il Cliente accetta che le leggi di controllo sulle esportazioni locali
    (rispetto al paese in cui vengono utilizzati i Servizi) governano il tuo utilizzo dei Servizi
    (inclusi i dati tecnici) e qualsiasi prodotto dall'accesso ai e l'utilizzo dei Servizi, e il Cliente
    accetta di rispettare tali leggi e regolamenti sull'esportazione nella loro interezza (incluse i
    regolamenti sulle "esportazioni presunte e le "riesportazioni presunte"). Il Cliente accetta che
    nessun dato, informazione, programma software e/o materiale risultante dai Servizi (o da un prodotto
    diretto degli stessi) sarà esportato, direttamente o indirettamente, in violazione di queste leggi,
    o sarà utilizzato per qualsiasi scopo proibito da queste leggi, inclusi, ma senza limitazione,
    proliferazione di armi nucleari, chimiche o biologiche, o lo sviluppo di tecnologia missilistica.
  </div>
</div>

<div class="eula_point">
  <div><b>Q. Informazioni statistiche</b></div>
  <div class="eula_point_left">In deroga a quanto definito altrove in questo Contratto o altrove, Sharp
    può monitorare l'uso da parte del Cliente dei Servizi e l'uso dei Dati dei clienti in maniera
    aggregata e anonima, compilare statistiche, informazioni sull'uso e sulle prestazioni relative alla
    fornitura e al funzionamento dei Servizi, e può rendere tali informazioni pubblicamente disponibili
    ("Dati aggregati"), ammesso che tali Dati aggregati non identifichino il Cliente o rivelino Dati dei
  clienti. Sharp mantiene tutti i Diritti di proprietà intellettuale in tali Dati aggregati.</div>
</div>

<div class="eula_points"><b>R. Modifica dei termini</b>
<ol>
  <li> Sharp può rivedere o modificare i termini di questo Contratto occasionalmente a propria sola
    discrezione. Nell'eventualità in cui questi termini siano rivisti o modificati, gli
    Amministratori dovranno accettare i termini rivisti o modificati al primo accesso seguente la
    data effettiva di tale revisione o modifica. La versione corrente di questo Contratto sarà
    pubblicato sul <a tabindex="-1" class="text_underline" [href]="termsUseUrl" target="_blank">Sito
  di assistenza Synappx</a> e il Cliente ha la responsabilità di controllare il sito
  regolarmente. Sharp effettuerà sforzi ragionevoli per fornire un avviso con trenta (30) giorni
  di anticipo alla data effettiva di cambiamento, ma alcuni cambiamenti potrebbero essere
effettivi con un avviso con un anticipo inferiore a trenta (30) giorni.</li>
<li> Se il Cliente continua a usare i Servizi dopo la data effettiva del Contratto rivisto o
  modificato, il Cliente accetta che lui/lei, gli Amministratori e i rispettivi Utenti finali
  saranno legati dai nuovi termini. Se il Cliente non accetta i termini rivisti del Contratto, il
Cliente può scegliere di terminare l'accesso ai e l'utilizzo dei Servizi.</li>
</ol>
</div>
<div class="eula_points"><b>S. Termini aggiuntivi</b>
<ol>
  <li> Il Cliente accetta che non c'è alcuna partnership, joint venture o relazione di agenzia tra
  Sharp e il Cliente.</li>
  <li> A meno che il Cliente non avvisi specificamente Sharp in forma scritta della propria
    contrarietà, Sharp può includere il nome del Cliente in un elenco di clienti sui materiali di
  marketing di Sharp, inclusi siti web.</li>
  <li> Eccetto per quanto specificato diversamente in questo Contratto, gli avvisi generali da Sharp
    al Cliente o agli Utenti finali relativi a questo contratto o ai Servizi saranno pubblicati sul
    <a tabindex="-1" class="text_underline" [href]="supportType" target="_blank">Sito di assistenza
    Synappx</a>. Il Cliente e gli Utenti finali dovrebbero pertanto visitare regolarmente il <a
    tabindex="-1" class="text_underline" [href]="supportType" target="_blank">Sito di assistenza
  Synappx</a> al fine di essere a conoscenza di tali avvisi eventuali. Avvisi specifici
  riguardo ai Servizi saranno inviati pubblicamente all'email dell'Amministratore. Eventuali
  comunicazioni che includano avvisi di carattere legale, domande o commenti relativi a questo
  Contratto dovranno essere diretti a: <br>
  <span>Synappx Product Manager</span>
  <div>Sharp Corporation </div>
  <div>492 Minosho-cho, Yamatokoriyama,</div>
  <div>Nara 639-1186, Giappone</div>
</li>
<li> Il Cliente non può assegnare o trasferire alcuna parte di questo Contratto senza previo
  consenso scritto di Sharp. Sharp può assegnare questo Contratto previo avviso al Cliente, che
  può assumere la forma di una email, un post o un messaggio attraverso i Servizi. In deroga a
  qualsiasi disposizione contraria, Sharp può assegnare questo Contratto a un'entità affiliata o
  in connessione con una fusione, acquisizione, riorganizzazione aziendale o vendita di tutti o
sostanzialmente tutti i propri asset senza fornire alcun avviso al Cliente.</li>
<li> La rinuncia di Sharp a qualsiasi infrazione o diritto sotto questo Contratto non sarà
considerata come una rinuncia di eventuali infrazione o diritto conseguente.</li>
<li> Se una disposizione di questo Contratto (o una parte di essa) viene ritenuta inapplicabile o
  contraria alla legge, sarà modificata nella misura minima necessaria per essere applicabile, e
le parti rimanenti di questo Contratto resteranno in pieno vigore ed effetto.</li>
<li> Questo Contratto e i Termini aggiuntivi, se presenti, costituiscono l'intero contratto tra il
  Cliente e Sharp riguardo ai Servizi e sostituiscono qualsiasi accordo e contratto precedente o
  contemporaneo, inclusi ordini di acquisto, che siano scritti o orali, riguardo alla materia di
questo Contratto.</li>
</ol>
</div>
</div>
</div>
<div mat-dialog-actions>
  <button mat-button class="primary_btn" (click)="agreeClick()" id="eula-id-agree-button"
  name="eula-name-agree-button">{{"Agree" |translate}}</button>
  <button #eulaCancelButton mat-button (click)="onCancel()" class="secondary_btn" id="eula-id-cancel-button"
  name="eula-name-cancel-button">{{"Decline" |translate}}</button>
</div>
</div>
